  <template>
  <question prevTitle="Back" nextTitle="Next" prevEnabled :nextEnabled="yes || no" @prevClick="$router.go(-1)" @nextClick="next">
    <div class="rounded shadow">
      <h3 class='pad inverted'>Is at least one director a homeowner?</h3>
      <div id="boolBar">
        <div @click="yesPress" :class="yes ? 'boolEnabled' : 'boolDisabled'">
          <h3>Yes</h3>
        </div>
        <div @click="noPress" :class="no ? 'boolEnabled' : 'boolDisabled'">
          <h3>No</h3>
        </div>
      </div>
    </div>
  </question>
</template>
<script>
import question from "@/components/questionTemplate";

export default {
  props: {
    nextRoute: {
      type: String,
      default: '5'
    }
  },
  components: {
    question
  },
  beforeMount: function () {
    if (this.$store.state.formData.homeOwners !== null) {
      if (this.$store.state.formData.homeOwners === true) {
        this.yes = true
      } else {
        this.no = true
      }
    }
  },
  methods: {
    next: function() {
      if (this.yes || this.no) {
        this.$store.dispatch('setFormData', {
          homeOwners: this.yes
        })
        this.$router.push(this.nextRoute);
      }
    },
    yesPress: function() {
      this.yes = !this.yes;
      this.no = false;
    },
    noPress: function() {
      this.no = !this.no;
      this.yes = false;
    }
  },
  data: function() {
    return {
      yes: false,
      no: false
    };
  }
};
</script>

<style lang="scss">
.pad {
  width: 100%;
  padding: 2em;
  box-sizing: border-box;
}
.boolEnabled {
  margin: 1em;
  padding: 0.75em;
  border-radius: 7px;
  min-width: 100px;
  background-color: var(--base-colour, #535450);
  color: white;
  border: solid var(--base-colour, #535450) 2px;
}
.boolDisabled {
  margin: 1em;
  padding: 0.75em;
  border-radius: 7px;
  min-width: 100px;
  border: solid var(--base-colour, #535450) 2px;
}
#boolBar {
  margin-top: 2em;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>